export const hcLanguages = [
  { name: 'English (US)', hcLang: true, code: 'English (US)', ampSearchLocale: "en" },
  { name: 'Arabic', hcLang: true, code: 'Arabic' },
  { name: 'Japanese', hcLang: true, code: 'Japanese' },
  { name: 'Turkish', hcLang: true, code: 'Turkish' },
  { name: 'Russian', hcLang: true, code: 'Russia' },
  { name: 'Korean', hcLang: true, code: 'Korean' },
  { name: 'Latin Spanish', hcLang: true, code: 'Latin Spanish' },
  { name: 'English (Nigerian)', hcLang: true, code: 'English (Nigerian)', ampSearchLocale: "en" },
  { name: 'English (British)', hcLang: true, code: 'English (British)', ampSearchLocale: "en"  },
  { name: 'English (Australian)', hcLang: true, code: 'English (Australian)', ampSearchLocale: "en" }
]
